import vpAccidental from 'src/assets/viewPlanMotor/vpAccidental.svg'
import vpConsequental from 'src/assets/viewPlanMotor/vpConsequental.svg'
import vpFire from 'src/assets/viewPlanMotor/vpFire.svg'
import vpIllegal from 'src/assets/viewPlanMotor/vpIllegal.svg'
import vpManMade from 'src/assets/viewPlanMotor/vpManMade.svg'
import vpMechanical from 'src/assets/viewPlanMotor/vpMechanical.svg'
import vpNatural from 'src/assets/viewPlanMotor/vpNatural.svg'
import vpTheft from 'src/assets/viewPlanMotor/vpTheft.svg'
import vpThirdParty from 'src/assets/viewPlanMotor/vpThirdParty.svg'
import vpTransit from 'src/assets/viewPlanMotor/vpTransit.svg'
import vpWar from 'src/assets/viewPlanMotor/vpWar.svg'
import vpWT from 'src/assets/viewPlanMotor/vpWT.svg'

export const FORM_ERROR_MESSAGES = {
  Name_Msg: 'Name is required',
  Mobile_Msg: 'Mobile Number is required',
  PreviousPolicyProvider_Msg: 'Previous Policy Provider is required',
  previousPolicyNumber_Msg: 'Previous Policy Number is required',
  PolicyType_Msg: 'PolicyType is required',
  existingPolicyClaim: 'Please select Atleast one option',
  ncb: 'Please select NCB Percentage',
  isPolicyExpired: 'Please select Atleast one option',
  isPolicyExpiredBeforeDate: '',
  expiryDate: 'Please Select the Expiry Date',
  expiredDate: 'Please Select the Expired Date',
  time: 'Time is required',
}

export const DRIVE_VARIABLES = [
  {
    label: '2,500 km/yr',
    value: '2500',
  },
  {
    label: '5,500 km/yr',
    value: '5500',
  },
  {
    label: '7,500 km/yr',
    value: '7500',
  },
  {
    label: '10,500 km/yr',
    value: '10500',
  },
  {
    label: 'Unlimited km/yr',
    value: 'unlimited',
  },
]

export const DRIVE_FEATURES = [
  { id: 1, name: 'Key and Lock Replacement' },
  { id: 2, name: 'Consumable' },
  { id: 3, name: 'NCB Protection' },
  { id: 4, name: 'Engine Protection' },
  { id: 5, name: '24x7 Roadside Assistance' },
]

export const FEATURE_ACTIONS = [
  {
    id: 1,
    image: 'advice',
    heading: 'Expert Advice',
    content:
      'With Trovity as your advisor, you gain access to our team of insurance experts who will assist you in understanding the intricacies of car insurance and help you choose the best policy for your unique requirements.',
  },
  {
    id: 2,
    image: 'coverage',
    heading: 'Comprehensive Coverage Options',
    content:
      'We offer a wide array of coverage options, ensuring that you get the protection you need. Whether its third-party liability, own damage, personal accident cover, or additional add-ons, we have got you covered.',
  },
  {
    id: 3,
    image: 'customization',
    heading: 'Customization at Your Fingertips',
    content:
      'We believe in empowering our customers, and with Trovity, you can tailor your car insurance policy with add-ons and coverage limits that suit your preferences.',
  },
  {
    id: 4,
    image: 'assistance',
    heading: 'Hassle-Free Claims Assistance',
    content:
      'When you need to make a claim, our streamlined process ensures a seamless experience. Our team will guide you through the necessary steps, making the entire claims process hassle-free.',
  },
  {
    id: 5,
    image: 'bonus',
    heading: 'No Claim Bonus Benefits',
    content:
      'At Trovity, we recognize your safe driving record. As a reward for claim-free years, you can enjoy attractive discounts on your premiums.',
  },
  {
    id: 6,
    image: 'convenience',
    heading: 'Online Convenience',
    content:
      'Experience the ease of managing your car insurance online with Trovitys user-friendly platform. From purchasing a policy to renewals, everything is just a few clicks away.',
  },
  {
    id: 7,
    image: 'longTerm',
    heading: 'Long-Term Protection',
    content:
      'Choose from our extended policy options for long-term coverage, providing you with peace of mind for up to three years.',
  },
  {
    id: 8,
    image: 'trust',
    heading: 'Trust and Reliability',
    content:
      'With Trovity as your advisor, you can rest assured that you are dealing with a trusted partner. We prioritize your interests and strive to provide the best solutions for your car insurance needs.',
  },
]

export const MOTOR_PLAN_DETAILS = [
  {
    title: 'Personal Accident (PA) Cover',
  },
]
export const MOTOR_INSURANCE_FEATURES = [
  {
    title: 'Invoice cover',
    content: '',
    toolTipText:// prettier-ignore
      'Only covers damage or injury caused to others by your vehicle. Doesn\'t cover damages to your own vehicle or injuries to you. Consider comprehensive insurance for full protection.',
  },
  {
    title: '24x7 Roadside Assistance',
    content: '',
    toolTipText:// prettier-ignore
      'Only covers damage or injury caused to others by your vehicle. Doesn\'t cover damages to your own vehicle or injuries to you. Consider comprehensive insurance for full protection.',
  },
  {
    title: 'Engine Protector',
    content: 'Car and third party',
    toolTipText:// prettier-ignore
      'Only covers damage or injury caused to others by your vehicle. Doesn\'t cover damages to your own vehicle or injuries to you. Consider comprehensive insurance for full protection.',
  },
  {
    title: 'NCB Protection',
    content: '',
    toolTipText:// prettier-ignore
      'Only covers damage or injury caused to others by your vehicle. Doesn\'t cover damages to your own vehicle or injuries to you. Consider comprehensive insurance for full protection.',
  },
  {
    title: 'Consumable',
    content: '',
    toolTipText:// prettier-ignore
      'Only covers damage or injury caused to others by your vehicle. Doesn\'t cover damages to your own vehicle or injuries to you. Consider comprehensive insurance for full protection.',
  },
  {
    title: 'Key and Lock Replacement',
    content: '',
    toolTipText:// prettier-ignore
      'Only covers damage or injury caused to others by your vehicle. Doesn\'t cover damages to your own vehicle or injuries to you. Consider comprehensive insurance for full protection.',
  },
  {
    title: 'Personal Accident Cover',
    content: 'Covers damages to your car and third party',
    toolTipText:// prettier-ignore
      'Only covers damage or injury caused to others by your vehicle. Doesn\'t cover damages to your own vehicle or injuries to you. Consider comprehensive insurance for full protection.',
  },
]

export const VEHICLE_NUMBER_REGEX = /^[A-Za-z]{2}\d{1,2}[A-Za-z]{0,3}\d{1,4}$/

export const POLICY_TYPE_ENUM = {
  THIRD_PARTY: 'THIRD_PARTY',
  OWN_DAMAGE: 'OWN_DAMAGE',
  COMPREHENSIVE: 'COMPREHENSIVE',
}

export const POLICY_TYPE_MOTOR = {
  THIRD_PARTY: 'Third Party',
  OWN_DAMAGE: 'Own Damage',
  COMPREHENSIVE: 'Comprehensive',
}

export const ncbValueObjectList = [
  { option: '0%', value: 0 },
  { option: '20%', value: 20 },
  { option: '25%', value: 25 },
  { option: '35%', value: 35 },
  { option: '45%', value: 45 },
  { option: '50%', value: 50 },
  { option: '60%', value: 60 },
  { option: '65%', value: 65 },
]

export const nomineeRelationType = [
  { relation: 'Self', value: 'SELF' },
  { relation: 'Father', value: 'FATHER' },
  { relation: 'Mother', value: 'MOTHER' },
  { relation: 'Brother', value: 'BROTHER' },
  { relation: 'Sister', value: 'SISTER' },
  { relation: 'Wife', value: 'WIFE' },
  { relation: 'Spouse', value: 'SPOUSE' },
  { relation: 'Mother In Law', value: 'MOTHER_IN_LAW' },
  { relation: 'Father In Law', value: 'FATHER_IN_LAW' },
  { relation: 'Son', value: 'SON' },
  { relation: 'Daughter', value: 'DAUGHTER' },
  { relation: 'Grand Father', value: 'GRANDFATHER' },
  { relation: 'Grand Mother', value: 'GRANDMOTHER' },
  { relation: 'Step Son', value: 'STEPSON' },
  { relation: 'Step Daughter', value: 'STEPDAUGHTER' },
]

export const RELATION_TYPES = {
  SELF: 'Self',
  FATHER: 'Father',
  MOTHER: 'Mother',
  BROTHER: 'Brother',
  SISTER: 'Sister',
  WIFE: 'Wife',
  SPOUSE: 'Spouse',
  MOTHER_IN_LAW: 'Mother In Law',
  FATHER_IN_LAW: 'Father In Law',
  SON: 'Son',
  DAUGHTER: 'Daughter',
  GRANDFATHER: 'Grand Father',
  GRANDMOTHER: 'Grand Mother',
  STEPSON: 'Step Son',
  STEPDAUGHTER: 'Step Daughter',
}

export const AADHAR_NO_REGEX = /^[2-9]\d{11}$/

export const PAN_NO_REGEX = /^[A-Za-z]{5}\d{4}[A-Za-z]$/

export const IFSC_REGEX = /^[A-Z]{4}0[A-Z0-9]{6}$/

export const PHONE_REGEX = /^(\+91[-\s]?)?0?(91)?[6789]\d{9}$/

export const NAME_REGEX = /^[A-Za-z]+(?:[-\s'][A-Za-z]+)*\s*$/

export const PINCODE_REGEX = /^[1-9]\d{2}\d{3}$/

export const COMPANY_GSTIN_REGEX = /^\d{2}[A-Z]{5}\d{4}[A-Z]1[A-Z0-9]$/
export const COMPANY_PAN_REGEX = /^[A-Z]{5}\d{4}[A-Z]$/
export const POLICY_NUMBER_REGEX = /^(?![A-Za-z]*$).{8,}$/

export const MOTOR_MEMBER_DETAILS_VALIDATIONS = {
  carOwnedBy: 'Please Select Atleast One Option',
  companyName: 'Please Enter Company Name',
  companyPan: 'Please Enter Company PAN',
  companyIncorporationDate: 'Please Enter Company Incorporation Date',
  companyGstin: 'Please Enter Company GSTIN',
  externalCngLpgKit: 'Please Select Atleast One Option',
  externalCngLpgKitAmount: 'Please Enter the CNG Kit Amount',
  isCurrentCarLoan: 'Please Select Atleast One Option',
  currentCarLoanProvider: 'Please Select the Loan Provider',
  branchName: 'Please enter the Branch Name',
  insuredPersonName: 'Please Enter the Name',
  email: 'Please Enter Email',
  mobileNumber: 'Please Enter Mobile Number',
  dateOfBirth: 'Please Enter Date of Birth',
  gender: 'Please Select Gender',
  pan: 'Please Enter PAN Number',
  aadhar: '',
  dateOfBirthValidation: 'Age Should be greater than or equal to 18',
  manufacturingYear: 'Please select the manufacturing year.',
  manufacturingMonth: 'Please select the manufacturing month.',
  fullAddress: 'Please enter the full address',
  pincode: 'Please enter the pincode',
  city: 'Please enter the city',
  state: 'Please enter the state',
  nomineeFirstName: 'Please enter the nominee Firstname',
  nomineeLastName: 'Please enter the nominee Lastname',
  nomineeDOB: 'Please enter the nominee Date Of Birth',
  nomineeRelation: 'Please select the relation',
  nomineeGender: 'Please select the nominee gender',
  lastName: 'Please enter the last name',
  nameValidation: 'Please Enter a Valid Name',
  isValidNameValidation: 'Please Enter a valid Name',
  phoneValidation: 'Please enter the valid phone number',
  pincodeValidation: 'Please enter the valid pincode',
  emailValidation: 'Please enter the valid email ',
  panValidation: 'Please enter the valid pan number',
  aadharValidation: 'Please enter the valid aadhar number',
  policyNumberLength: 'Invalid policy number',
  companyPanValidation: 'Please enter valid PAN number',
  gstinValidation: 'Please enter valid gstin number',
  engineNumber: 'Please enter engine number',
  chassisNumber: 'Please enter chassis number',
  thirdPartyPolicyNumber: 'Please enter Policy number',
  thirdPartyInsuranceProvider:
    'Please enter third party insurance provider name',
  thirdPartyStartDate: 'Please enter third party start date',
  thirdPartyExpiryDate: 'Please enter third party expiry date',
}

export const MOTOR_VEHICLE_DETAILS_POPOVER_ELEMENTS = {
  EDIT_NCB_PERCENTAGE: 'editNcbPercentage',
  EDIT_POLICY_EXPIRY_DETAILS: 'editPolicyExpiryDetails',
}

export const MOTOR_NCB_CLIAM = {
  YES: 'yes',
  NO: 'no',
}

export const MOTOR_POLICY_EXPIRE_DETAILS = {
  NotExpired: 'notExpired',
  Expired: 'expired',
}

export const MOTOR_FUEL_TYPES = {
  HYBRID: 'Hybrid',
  CNG: 'Cng',
  BATTERY: 'Battery',
  DIESEL: 'Diesel',
  PETROL: 'Petrol',
  LPG: 'Lpg',
  ELECTRIC: 'Electric',
  ANY_OTHER: 'Any Other',
}

// Motor Tooltips

export const ncbTooltip = {
  ncbOne:
    ' NCB is a reward given by an insurance company to an insured for not raising any claim requests during a policy year.',
  ncbTwo:
    '  The NCB is a discount ranging between 20%-50% and is given to the insured while renewing a policy.',
}

export const viewPlanCovered = [
  {
    logo: vpAccidental,
    text: 'Car Accidents',
    toolTipText:
      'Protects your car from accidents, theft, natural disasters, manmade incidents, fire, explosions, or transit-related damages.',
  },
  {
    logo: vpTheft,
    text: 'Car theft',
    toolTipText:
      'This policy safeguards against losses arising from the unfortunate theft of your car',
  },
  {
    logo: vpNatural,
    text: 'Damage from natural disasters (like floods or storms)',
    toolTipText:
      'This policy provides coverage for damages to your car and losses resulting from natural calamities like cyclones, floods, and earthquakes.',
  },
  {
    logo: vpManMade,
    text: 'Damage from human-made dangers (like vandalism)',
    toolTipText:
      'This policy offers coverage for damages to your car and losses resulting from man-made hazards like terrorist attacks or fires.',
  },
  {
    logo: vpFire,
    text: 'Loss from fires and explosions',
    toolTipText:
      'This policy covers damages and losses to your car caused by accidental fires.',
  },
  {
    logo: vpTransit,
    text: 'Damage during transportation',
    toolTipText:
      'This policy covers damages and losses to your car that occur during transit from one place to another.',
  },
]

export const viewPlanNotCovered = [
  {
    logo: vpWT,
    text: 'Regular use wear and tear',
    toolTipText:
      'Any losses resulting from the usual wear and tear of the vehicle will not qualify for a claim.',
  },
  {
    logo: vpThirdParty,
    text: 'Damage to third party',
    toolTipText:
      'This policy does not cover damages to third parties, including other individuals, vehicles, or properties involved in the accident.',
  },
  {
    logo: vpMechanical,
    text: 'Machinery breakdown',
    toolTipText:
      'Mechanical or electrical breakdowns, failure of chassis or body parts, and breakage due to rust or weather conditions are not eligible for claims under this policy.',
  },
  {
    logo: vpConsequental,
    text: 'Resulting damage',
    toolTipText:
      'Any damage not directly resulting from the claimed accident, such as additional harm caused to the engine while driving the damaged car post-accident, is not covered under this policy.',
  },
  {
    logo: vpIllegal,
    text: 'Unlawful driving and activities',
    toolTipText:// prettier-ignore
      'Your claim won\'t be approved if the driver didn\'t have a valid license, was under the influence of intoxicating substances, used the car for commercial purposes, or was involved in racing during the accident. Deliberate damage or damage occurring during riots involving you also disqualifies your claim.',
  },
  {
    logo: vpWar,
    text: 'Harm caused by war or invasion',
    toolTipText:// prettier-ignore
      'This policy doesn\'t cover losses resulting directly or indirectly from war, invasion, acts of foreign enemies, hostilities, civil war, mutiny, rebellion, or military actions.',
  },
]

export const getNextDate = (date) => {
  const nextDay = new Date(date)
  nextDay.setDate(nextDay.getDate() + 1)
  return nextDay
}

export const vehicleType = {
  TWO_WHEELER: 'TWO_WHEELER',
  FOUR_WHEELER: 'FOUR_WHEELER',
}
